module.exports = __webpack_public_path__ + "static/media/4540.aaa61c0f.jpg";